import request from '@/utils/request'

export function getTenantInfo(tenantCode) {
  return request({
    url: `/system/tenant/info`,
    method: 'get',
    params: {
      tenantCode
    }
  })
}